import Vue from 'vue'

Vue.prototype.$actionList = 'list'
Vue.prototype.$actionNew = 'new'
Vue.prototype.$actionEdit = 'edit'
Vue.prototype.$actionDetail = 'detail'
Vue.prototype.$actionDelete = 'delete'
